<kp-eligibility-header></kp-eligibility-header>
<kp-eligibility [eligibilityType]="eligibilityType"></kp-eligibility>
